export default __webpack_public_path__ + "static/summer_containers19-000836a3de7923a51c780d6e518a4273.webp";